import React from "react";
import { Col, Row, Input, Label, FormGroup } from "reactstrap";
import { Fragment } from "react";
export default function AgencyPreviewform(props) {
  const { document = [], Answer = [], isEditable } = props;
  console.log(Answer, "Answer");
  return (
    <>
      {Answer.map((a) => (
        <>
          <h5 style={{ marginTop: "20px" }}>{a.categoryName}</h5>
          <Row>
            {(a.categoryPlaceHolder || []).map((f, order) => (
              <>
                {["text", "textarea", "date", "time"].includes(f.type) ? (
                  <Col md="4">
                    <FormGroup>
                      <Label>
                        {" "}
                        {order + 1}. {f.label}
                      </Label>
                      <Input
                        value={f.selectedAnswer}
                        disabled={isEditable}
                        type={f.type}
                        placeholder={f.placeholder}
                      ></Input>
                    </FormGroup>
                  </Col>
                ) : (
                  ""
                )}
                {f.type === "select" && (
                  <Col md="4">
                    <Label>
                      {order + 1}. {f.label}
                    </Label>{" "}
                    <FormGroup>
                      {" "}
                      <Input
                        disabled={isEditable}
                        value={f.selectedAnswer}
                        type={f.type}
                        placeholder={f.placeholder}
                      >
                        {" "}
                        {f.options.map((o) => (
                          <option value={o.value}>{o.value}</option>
                        ))}{" "}
                      </Input>
                    </FormGroup>{" "}
                  </Col>
                )}
                {f.type === "radio" && (
                  <>
                    <FormGroup>
                      <Label>
                        {order + 1}.{f.label}
                      </Label>
                      {f.options.map((o, index) => (
                        <>
                          <Col md="4">
                            <Label check>
                              <Input
                                disabled={isEditable}
                                checked={f.selectedAnswer === o.value}
                                type="radio"
                                id=""
                                name={f.uniqueId}
                              />
                              {o.value}
                            </Label>
                          </Col>{" "}
                        </>
                      ))}
                    </FormGroup>
                  </>
                )}

                {f.type === "checkbox" && (
                  <>
                    <Col md="4">
                      <FormGroup check>
                        <Label>
                          {order + 1}.{f.label}
                        </Label>
                        {f.options.map((o, index) => (
                          <>
                            <Col md="12">
                              <Label check>
                                <Input
                                  disabled={isEditable}
                                  // value={f.selectedAnswer}
                                  checked={f.selectedAnswer.includes(
                                    o.value || ""
                                  )}
                                  type="checkbox"
                                  name={f.uniqueId}
                                />{" "}
                                {o.value}&nbsp;{" "}
                              </Label>
                            </Col>
                          </>
                        ))}{" "}
                      </FormGroup>{" "}
                    </Col>
                  </>
                )}
              </>
            ))}
          </Row>
          <AdditionalDoc answer={a} document={document} />
        </>
      ))}
    </>
  );
}

export const AdditionalDoc = (props) => {
  const { answer = {}, document = [] } = props;
  const documents = document.filter(
    (doc) => doc.categoryId === answer.categoryId
  );

  if (!documents.length) return false;
  return (
    <>
      <Label>Additional Document</Label>

      <Row>
        {documents.map((doc) => (
          <Fragment key={doc.licenseRequiredDocId}>
            {doc.filePath && (
              <Col md="4">
                <a
                  href={doc.filePath}
                  style={{ cursor: "pointer" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="#1b3e6f6b"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z" />
                    <path d="M14 3v5h5M16 13H8M16 17H8M10 9H8" />
                  </svg>
                  <Label>
                    {" "}
                    {doc.documentName}
                    {doc.isMandatory ? "*" : ""}{" "}
                  </Label>{" "}
                </a>
              </Col>
            )}
          </Fragment>
        ))}
      </Row>
    </>
  );
};
